import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useEditPauseCodeQuery, useEditPauseMutation } from '../../../../Services/Telephony/Telephony';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

interface IPROPS {
    closeModal: any;
    pauseId: any;
    refetch: any;
    pauseCode: any; // Ensure pauseCode is passed!
}

const EditPauseCode: React.FC<IPROPS> = ({ closeModal, pauseId, refetch,pauseCode}) => {
    const [pauseCodeName, setPauseCodeName] = useState('');
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    // const [pcDuration, setPcDuration] = useState(dayjs().startOf('day'));
      const [pcDuration, setPcDuration] = useState<dayjs.Dayjs | null>(null);

    const { data: editPauseCodeData } = useEditPauseCodeQuery(pauseId);
    const [trigger] = useEditPauseMutation();

    // useEffect(() => {
    //     if (editPauseCodeData) {
    //         setPauseCodeName(editPauseCodeData?.name);
    //         const [h, m, s] = editPauseCodeData?.pc_duration.split(':').map(Number);
    //         setPcDuration(dayjs().hour(h).minute(m).second(s));
    //     }
    // }, [editPauseCodeData, pauseId]);

  useEffect(() => {
    if (editPauseCodeData) {
      setPauseCodeName(editPauseCodeData?.name || '');
      if (editPauseCodeData?.pc_duration) {
        const [h, m, s] = editPauseCodeData.pc_duration.split(':').map(Number);
        setPcDuration(dayjs().hour(h).minute(m).second(s));
      }
    }
  }, [editPauseCodeData]);

    // const handleDurationChange = (newValue: dayjs.Dayjs | null) => {
    //     if (newValue) {
    //         setPcDuration(newValue);
    //     }
    // };

  const handleDurationChange = (newValue: dayjs.Dayjs | null) => {
    setPcDuration(newValue);
  };
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

    // Convert input to lowercase and trim spaces
    const lowerName = pauseCodeName.trim().toLowerCase();

    // Check if `pauseCode` exists and is an array
    if (!pauseCode || !Array.isArray(pauseCode)) {
        toast.error("Pause codes data is missing!");
        console.error("PauseCode List:", pauseCode);
        return;
    }

    // Ensure the list is correctly compared for duplicates while ignoring the current ID
    const isDuplicate = pauseCode.some((el) => el.name.trim().toLowerCase() === lowerName && el.id !== pauseId);

    if (isDuplicate) {
        toast.error(`${pauseCodeName} already exists.`);
        return;
    }
        // const obja = {
        //     name: pauseCodeName,
        //     pc_duration: pcDuration.format('HH:mm:ss'),
                // };
        const obja: any = {
            name: pauseCodeName.trim()
            };

            if (pcDuration) {
            obja.pc_duration = pcDuration.format('HH:mm:ss');
            }

        try {
            const response = await trigger({ body: obja, id: pauseId });

            if (response?.data) {
                toast.success('Edited successfully');
                closeModal();
                refetch();
            } 
        } catch (error) {
            toast.error('An error occurred');
        } finally {
            setIsButtonDisabled(true);
            setTimeout(() => {
                setIsButtonDisabled(false);
            }, 3000);
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div>
                <label>AUX code</label>
                <input
                    className="form-control"
                    value={pauseCodeName}
                    onChange={(e) => setPauseCodeName(e.target.value)}
                />
            </div>

            <div>
                <label>Duration (HH:MM:SS)</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                        views={['hours', 'minutes', 'seconds']}
                        ampm={false}
                        value={pcDuration}
                        onChange={handleDurationChange}
                        sx={{
                            width: '100%',
                            '& .MuiInputBase-root': {
                                width: '100%',
                            },
                        }}
                          slotProps={{
                            textField: {
                                placeholder: '00:00:00',
                            },
                        }}
                        
                    />
                </LocalizationProvider>
            </div>

            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    gap: '10px',
                    justifyContent: 'end',
                }}
            >
                <button
                    type="reset"
                    className="btn btn-sm btn-white me-2"
                    onClick={closeModal}
                >
                    Cancel
                </button>
                <button
                    className="btn btn-primary"
                    onClick={handleSubmit}
                    disabled={isButtonDisabled}
                >
                    Save
                </button>
            </div>
        </div>
    );
};

export default EditPauseCode;
